import { FC } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { leaves, routes } from "~/constants";
import { Protector } from "./Protector";
import {
  lazy,
  lazyLoadLandingPages,
  lazyLoadMemberPages,
  rrPath,
} from "./utils";

const AllSetPage = lazyLoadMemberPages("AllSetPage");

const BillingManagementPage = lazyLoadMemberPages("BillingManagementPage");

const CancellationReasonPage = lazyLoadMemberPages("CancellationReasonPage");

const ConfirmationPage = lazyLoadMemberPages("ConfirmationPage");

const DashboardPage = lazyLoadMemberPages("DashboardPage");

const NotFoundPage = lazyLoadLandingPages("NotFoundPage");

const PaymentIssuePage = lazyLoadMemberPages("PaymentIssuePage");

const PlanManagementPage = lazyLoadMemberPages("PlanManagementPage");

const ReferAFriendPage = lazyLoadMemberPages("ReferAFriendPage");

const SetPasswordPage = lazyLoadMemberPages("SetPasswordPage");

const SettingsPage = lazyLoadMemberPages("SettingsPage");

export const MemberRoutes: FC = () => {
  return (
    <Routes>
      <Route
        index
        element={
          <Protector
            requireAuth
            requireGoodStanding
            requireOnboarding
            requirePayment
          >
            <Navigate replace={true} to={routes.dashboard} />
          </Protector>
        }
      />
      <Route
        path={rrPath(leaves.settings)}
        element={<Protector requireAuth>{lazy(<SettingsPage />)}</Protector>}
      />
      <Route
        path={rrPath(leaves.managePlan)}
        element={
          <Protector requireAuth>{lazy(<PlanManagementPage />)}</Protector>
        }
      />
      <Route
        path={rrPath(leaves.cancellationReason)}
        element={
          <Protector requireAuth>{lazy(<CancellationReasonPage />)}</Protector>
        }
      />
      <Route
        path={rrPath(leaves.manageBilling)}
        element={
          <Protector requireAuth>{lazy(<BillingManagementPage />)}</Protector>
        }
      />
      <Route
        path={rrPath(leaves.referAFriend)}
        element={
          <Protector
            requireAuth
            requireGoodStanding
            requireOnboarding
            requirePayment
            requireSetPassword
          >
            {lazy(<ReferAFriendPage />)}
          </Protector>
        }
      />
      <Route
        path={rrPath(leaves.allSet)}
        element={
          <Protector
            requireAuth
            requireGoodStanding
            requireOnboarding
            requirePayment
            requireSetPassword
          >
            {lazy(<AllSetPage />)}
          </Protector>
        }
      />
      <Route
        path={rrPath(leaves.dashboard)}
        element={
          <Protector
            requireAuth
            requireGoodStanding
            requireOnboarding
            requirePayment
            requireSetPassword
          >
            {lazy(<DashboardPage />)}
          </Protector>
        }
      />
      <Route
        path={rrPath(leaves.program)}
        element={<Navigate to={routes.dashboard} />}
      />
      <Route
        path={rrPath(leaves.setPassword)}
        element={
          <Protector
            requireAuth
            requireOnboarding
            requirePayment
            protectSetPassword
          >
            {lazy(<SetPasswordPage />)}
          </Protector>
        }
      />
      <Route
        path={rrPath(leaves.paymentIssue)}
        element={
          <Protector protectPaymentIssue requireAuth>
            {lazy(<PaymentIssuePage />)}
          </Protector>
        }
      />
      <Route
        path={rrPath(leaves.confirmation)}
        element={
          <Protector requireAuth requireOnboarding>
            {lazy(<ConfirmationPage />)}
          </Protector>
        }
      />
      <Route path="*" element={lazy(<NotFoundPage />)} />
    </Routes>
  );
};
